import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";

const PayRentStatus = loadable(() => import("./PayRentStatus"), {
  fallback: <FullPageLoader />,
});

export default PayRentStatus;
